export default {
  PNG: ".png",
  OBJ: ".obj",
  JPG: ".jpg",
  FBX: ".fbx",
};
